module.exports = __webpack_public_path__ + "img/5.b98f8945.png";